import React from "react";
import {FarmyImage} from "../tools/nextjs-compatibility-layer";
import styled from "styled-components";
import currentTheme from "../../react-themes/theme";
import {t} from "../../shared-services/translate";
import {mediaQuery} from "../shared/GlobalStyles";
import NewsletterForm from "../shared/NewsletterForm";
import useTracking from "../../react-services/useTracking";

import {useSelector} from "../../shared-services/redux-tiny";

const theme = currentTheme();

const imgFolder = "components/shared/SiteFooter";

const mobileBreakpoint = "850px";

const currentYear = new Date().getFullYear();

const data = {
  awards: [
    {src: `${imgFolder}/trusted-shops-badge.webp`, alt: "Trusted shops", href: "https://www.trustedshops.ch/bewertung/info_XC41A6F67DA01EF4108CC6FE6DBCE521C.html", height: "auto", width: 55},
    {src: `${imgFolder}/ecommerce-award.webp`, alt: "Ecommerce award 2018", href: "https://digital-commerce-award.ch/uebersicht-sieger/", height: "auto", width: 55},
    {src: `${imgFolder}/swiss_ecommerce_association.webp`, alt: "Swiss ecommerce association", href: "https://www.swiss-online-garantie.ch/", height: "auto", width: 55},
    {src: `${imgFolder}/bcorp-certificate.webp`, alt: "BCorp certificate", href: "https://www.farmy.ch/ct/farmy-ist-b-corp-zertifiziert", height: "auto", width: 45}
  ],
  payments: [
    {class: "twint-resize", src: `${imgFolder}/footer_payment_logo_twint.webp`, alt: "Twint"},
    {class: "", src: `${imgFolder}/footer_payment_logo_cards.webp`, alt: "Visa Mastercard"},
    {class: "amex-resize", src: `${imgFolder}/footer_payment_logo_amex_full.webp`, alt: "American Express"},
    {class: "", src: `${imgFolder}/footer_payment_logo_paypal.webp`, alt: "Paypal"},
    {class: "", src: `${imgFolder}/footer_payment_logo_pointspay.webp`, alt: "Pointspay"},
    {class: "", src: `${imgFolder}/footer_payment_logo_postfinance.webp`, alt: "PostFinance"},
    {class: "", src: `${imgFolder}/footer_payment_rechnung_icon.webp`, alt: "Rechnung"},
    {class: "cembrapay-resize", src: `${imgFolder}/footer_payment_logo_cembrapay.webp`, alt: "CembraPay"}
  ],
  socials: [
    {class: "facebook", icon: "social-logo fa fa-facebook", alt: "Facebook", href: "https://www.facebook.com/farmy.ch"},
    {class: "twitter", icon: "social-logo fa fa-twitter", img: `${imgFolder}/twitter.svg`, alt: "Twitter", href: "https://twitter.com/farmyCH"},
    {class: "instagram", icon: "social-logo fa fa-instagram", alt: "Instagram", href: "https://www.instagram.com/farmy_ch"},
    {class: "youtube", icon: "social-logo fa fa-youtube", alt: "YouTube", href: "https://www.youtube.com/channel/UCv6zohUoy1j3XxK2u1MtFWQ"}
  ],
  navLinks: [
    {class: null, href: {de: "/ct/uber-uns", "fr-CH": "/ct/a-propos", en: "/ct/about-us"}, target: "_blank", text: "spree.shared.footer.about_us"},
    {class: null, href: {de: "/suppliers", "fr-CH": "/fr-CH/suppliers", en: "/en/suppliers"}, target: "_blank", text: "our_producers"},
    {class: null, href: {de: "/pl", "fr-CH": "/fr-CH/pl", en: "/en/pl"}, target: "_blank", text: "cms.blog.title.product_knowledge"},
    {class: null, href: {de: "/pl/impressum", "fr-CH": "/fr-CH/pl/impressum", en: "/en/pl/impressum"}, target: "_blank", text: "spree.shared.footer.impressum"}
  ],
  navLinks2: [
    {class: null, href: {de: "https://farmy.join.com/", "fr-CH": "https://farmy.join.com/", en: "https://farmy.join.com/"}, text: "spree.shared.footer.carrier", target: "_blank", rel: "noreferrer"},
    {class: null, href: {de: "/agb", "fr-CH": "/fr-CH/cgv", en: "/en/gtc"}, text: "spree.shared.footer.terms_of_service", target: "_blank", rel: ""},
    {class: null, href: {de: "/ct/datenschutzerklarung", "fr-CH": "/ct/declaration-de-protection-des-donnee", en: "/ct/data-protection"}, text: "spree.shared.footer.data_protection", target: "_blank", rel: ""},
    {class: null, href: {de: "/kontakt", "fr-CH": "/fr-CH/contact", en: "/en/contact"}, text: "spree.shared.footer.contact", target: "_blank", rel: ""},
    {class: "visible-mobile", href: {de: "/pl", "fr-CH": "/fr-CH/pl", en: "/en/pl"}, text: "cms.blog.title.product_knowledge", target: "_blank", rel: ""},
    {class: "visible-mobile", href: {de: "/pl/impressum", "fr-CH": "/fr-CH/pl/impressum", en: "/en/pl/impressum"}, target: "_blank", text: "spree.shared.footer.impressum"},
    {class: "farmypass-link", href: {de: "/farmypass/new", "fr-CH": "/fr-CH/farmypass/new", en: "/en/farmypass/new"}, accountHref: "/account#farmypass_preferences", text: "farmypass.farmypass", target: "_blank", rel: ""},
    {class: null, href: {de: "#", "fr-CH": "#", en: "#"}, text: "spree.shared.footer.change_hubs", target: "", rel: "", onClick: window.Hubs.openZipcodeModal}
  ]
};

const SiteFooter = (props) => {
  const locale = window.I18n.locale || "de";
  const currentUser = useSelector(state => state.session.currentUser);

  const {trackEvent} = useTracking();

  return <StyledFooter>
    <div className='footer-content full-width'>
      <NewsletterContactInfo>
        {currentUser && Object.keys(currentUser).length === 0 && <NewsletterForm />}
        <div className="footer-group">
          <div dangerouslySetInnerHTML={{__html: t("spree.shared.footer.contact_form.cta")}} />
          <div className="footer-nav">
            <ul>
              {
                data.navLinks.map((link, index) => <li key={index} className={link.class}><a href={link.href[locale]} target={link.target}>{t(link.text) || ""}</a></li>)
              }
            </ul>
          </div>
        </div>
      </NewsletterContactInfo>
      <FarmyInternalLinks>
        <ul>
          {
            data.navLinks2.map((link, index) =>
              <li key={index} className={link.class}>
                <a href={link.class === "farmypass-link" && currentUser?.smartPass ? link.accountHref : link.href[locale]}
                  target={link.target}
                  rel={link.rel}
                  onClick={link?.onClick}
                >{t(link.text) || ""}</a>
              </li>
            )
          }
          <li>
            {!window.currentZipcode &&
              <button className={"link-btn"} onClick={() => window.Hubs.openZipcodeModal({redirectUrl: t("shipping_costs.delivery_cost_details_page.link"), newTab: true})}>
                {t("spree.shared.footer.delivery_information")}
              </button>
            }
            {window.currentZipcode &&
              <a href={t("shipping_costs.delivery_cost_details_page.link")} target={"_blank"} rel={"noopener noreferrer"}>
                {t("spree.shared.footer.delivery_information")}
              </a>
            }
          </li>
        </ul>
      </FarmyInternalLinks>
      <AwardsAndSocial>
        <div className="awards-social-box">
          <Socials>
            {
              data.socials.map(social =>
                <a key={social.alt}
                  className={`social ${social.class}`}
                  href={window.currentHubId === 4 && social.class === "instagram" ? social.href + ".fr" : social.href}
                  target="_blank"
                  rel="noreferrer"
                  onClick={() => {
                    trackEvent("outboundLink",
                      {
                        gtmObject: {
                          eventName: "outboundLink",
                          type: "socialmedia",
                          detail: social.class
                        }
                      }
                    );
                  }}
                >
                  {
                    social.class === "twitter"
                      ? <FarmyImage width={"15px"} height={"15px"} src={social.img} alt={social.alt}/>
                      : <i className={social.icon} />
                  }
                </a>
              )
            }
          </Socials>
          <Awards className="awards-box">
            {
              data.awards.map((award, index) =>
                <a key={index} href={award.href} target='_blank' rel='noreferrer'
                  onClick={() => {
                    if (award.alt !== "BCorp certificate") {
                      trackEvent("outboundLink",
                        {
                          gtmOptions: {
                            eventName: "outboundLink",
                            type: "awards",
                            detail: award.alt.split(" ").join("-").toLowerCase()
                          }
                        }
                      );
                    }
                  }}
                >
                  <FarmyImage className="ecom-awards" width={award.width} height={award.height} src={award.src} alt={award.alt} />
                </a>
              )
            }
          </Awards>
        </div>
      </AwardsAndSocial>
      <FarmyLogo>
        <div className="footer-logo-link-wrapper">
          <a href="/">
            <div className="footer-logo-wrapper">
              <FarmyImage className="footer-farmy-logo" src={`${imgFolder}/main-logo.svg`} alt={t("spree.seo.logo.alt")}/>
              <div className="copyright">
                {`© ${currentYear} Farmy.ch`}
              </div>
            </div>
          </a>
        </div>
      </FarmyLogo>
      <PaymentLogos>
        <div className="payment-logos">
          {
            data.payments.map(payment => {
              if (payment.alt === "Rechnung") {
                return (
                  <div key={payment.alt} className='payment-logo-wrapper'>
                    <FarmyImage className={`payment-logo ${payment.class}`} height={350} src={payment.src} alt={t("spree.checkouts.payment.payment_methods.rechnung")} alt={payment.alt} />
                    <span>{t("spree.checkouts.payment.payment_methods.rechnung")}</span>
                  </div>
                );
              }
              return <FarmyImage key={payment.alt} className={`payment-logo ${payment.class}`} src={payment.src} alt={payment.alt} height={350} />;
            })}
        </div>
      </PaymentLogos>
    </div>
  </StyledFooter>;
};

export default SiteFooter;

const StyledFooter = styled.footer.attrs(() => ({
  className: `background-color-green
              padding-top-20
              full-width`
}))`
  font-size: 14px;
  color: white;
  &.hide-footer {
    ${mediaQuery("sm")`
      display: none;
    `}
  }
  
  a, .link-btn {
    color: white;
  }
  
  a:focus, .link-btn:focus {
    outline: none;
  }
  
  @media (max-width: ${mobileBreakpoint}) {
    padding: 20px 0px;
  }
  
  .footer-content {
    max-width: 1160px;
    margin: 0 auto;
    ${mediaQuery("lg")`
      max-width: 960px;
    `}
    
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    grid-template-rows: repeat(5, auto);
    grid-column-gap: 10px;
    
    &>* {
      padding: 0 10px;
    }
    
    @media (max-width: ${mobileBreakpoint}) {
      display: flex;
      flex-direction: column;
      gap: 30px;
    }
  }
  
  ul {
    margin: 0;
    padding: 0;
    list-style-type: none;
    
    li {
      margin: 0 0 10px 0;
      a, .link-btn {
        cursor: pointer;
        
        &:focus, &:hover {
          color: ${theme.colors.farmy.orange};
        }
      }
      .link-btn {
        border: none;
        margin: 0;
        padding: 0;
        outline: none;
        background-color: transparent;
        text-decoration: none;
      }
    }
  }
`;

const NewsletterContactInfo = styled.div`
  grid-column-start: 1;
  grid-column-end: 6;
  grid-row-start: 1;
  grid-row-end: 2;
  
  div:first-of-type>a{
    text-decoration: underline;
    &:focus, &:hover {
      color: ${theme.colors.farmy.orange};
    }
  }
  
  @media (max-width: ${mobileBreakpoint}) {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  
  .footer-group {
    display: flex;
    justify-content: space-between;
    width: 90%;
    
    ${mediaQuery("lg")`
        width: auto;
      `};
    
    @media (max-width: ${mobileBreakpoint}) {
      text-align: center;
    }
  }
  
  .footer-nav {
    margin-left: 10px;
    @media (max-width: ${mobileBreakpoint}) {
      display: none;
    }
  }
`;

const FarmyInternalLinks = styled.div`
  grid-column-start: 6;
  grid-column-end: 9;
  grid-row-start: 1;
  grid-row-end: 3;
  
  @media (max-width: ${mobileBreakpoint}) {
    text-align: center;
  }
  @media (min-width: ${mobileBreakpoint}) {
    .visible-mobile {
      display: none;
    }
  }
  button {
    
  }
`;

const AwardsAndSocial = styled.div.attrs(() => ({
  className: `flex
              flex-direction-column
              align-items-flex-end
              gap-30`
}))`
  grid-column-start: 9;
  grid-column-end: 13;
  grid-row-start: 1;
  grid-row-end: 3;
  
  .awards-social-box {
    display: flex;
    flex-direction: column;
    gap: 30px;
    float: right;
  }
  
  @media (max-width: ${mobileBreakpoint}) {
    align-items: center;
    .awards-social-box {
      float: none;
      justify-content: center;
      align-items: center;
    }
  }
`;

const PaymentLogos = styled.div`
  grid-column-start: 3;
  grid-column-end: 13;
  grid-row-start: 5;
  grid-row-end: 6;
  
  @media (max-width: ${mobileBreakpoint}) {
    display: none;
  }
  .payment-logos {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-wrap: wrap;
    width: 100%;
    gap: 10px;
    margin-bottom: 20px;
    
    @media (max-width: ${mobileBreakpoint}) {
      display: none;
    }
    
  }
  .payment-logo-wrapper {
    display: flex;
    align-items: center;
    span {
      font-size: 14px;
    }
  }
  
  .payment-logo {
    height: 50px;
    width: auto;
  }
  .amex-resize {
    height: 45px;
  }
  .twint-resize {
    height: 35px;
  }
  .cembrapay-resize {
    height: 25px;
    margin-left: 10px;
  }
`;

const FarmyLogo = styled.div`
  grid-column-start: 1;
  grid-column-end: 3;
  grid-row-start: 2;
  grid-row-end: 6;
  
  align-self: end;
  
  @media (max-width: ${mobileBreakpoint}) {
    display: none;
  }
  
  .footer-logo-link-wrapper {
    width: 130px;
    min-width: 130px;
    text-align: center;
  }
  
  .footer-logo-wrapper {
    padding: 10px 15px;
    background-color: white;
    border-radius: 8px 8px 0 0;
    box-shadow: 5px 4px 9px -3px black;
    position: static;
    
    .footer-farmy-logo {
      width: 100%;
      height: auto;
    }
    .copyright {
      color: #8f877f;
      font-size: 11px;
      margin-top: 10px;
    }
  }
`;

const Socials = styled.div`
  display: flex;
  justify-content: space-around;
  width: 180px;
  
  a {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: white;
    height: 36px;
    width: 36px;
    border-radius: 50%;
    transition: all ease-in-out 0.3s;
    
    &:focus, &:hover {
      .social-logo {
        color: white;
      }
    }
  }
  
  .social-logo {
    color: #392B1E;
    font-size: 18px;
    margin-left: 1px;
    transition: all ease-in-out 0.3s;
    &::before {
      margin: 0;
    }
  }
  
  .facebook {
    &:focus, &:hover {
      background-color: #3b5998;
    }
  }
  .twitter {
    &:focus, &:hover {
      background-color: #000000;
      
      img{
        filter: invert(1);
      }
    }
  }
  .instagram {
    &:focus, &:hover {
      background-color: #DD2A7B;
    }
  }
  .youtube {
    &:focus, &:hover {
      background-color: #CD1F29;
    }
  }
`;

const Awards = styled.div`
  &.awards-box {
    display: flex;
    flex-wrap: nowrap;
    justify-content: flex-end;
    
    a {
      pointer-events: auto;
    }
    a img {
      margin: 0 15px 20px 0;
    }
    a:last-child img {
      margin: -8px 0 0 0;
    }
  }
  
  @media (max-width: ${mobileBreakpoint}) {
    .awards-box {
      justify-content: center;
      flex-wrap: nowrap;
      width: 100%;
      
      a:nth-of-type(3) img{
        display: none;
      }
      a img {
        margin-right: 15px;
      }
      img, a:last-child img{
        margin: 0px;
      }
    }
  }
`;
